<template>
  <HgModal v-model="internalModel" data-cy="bulk-promotion-modal" @close="close">
    <template #title>{{ t('manageAdsPage.bulkPromotion.title') }}</template>

    <div :class="$style.content">
      <h3 :class="$style.status">{{ t('manageAdsPage.bulkPromotion.status') }}</h3>
      <p :class="$style.description">{{ t('manageAdsPage.bulkPromotion.description') }}</p>
    </div>

    <template #footer>
      <HgButton data-cy="bulk-promotion-modal-close-btn" @click="close">
        {{ t('general.buttons.close') }}
      </HgButton>
    </template>
  </HgModal>
</template>

<script setup lang="ts">
import { HgButton, HgModal } from '@smg-real-estate/domus';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  modelValue: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:modelValue', 'onClose']);
const { t } = useI18n();

const internalModel = computed({
  get() {
    return props.modelValue;
  },
  set(value: boolean) {
    emit('update:modelValue', value);
  },
});

const close = (): void => {
  emit('onClose');
};
</script>

<style lang="scss" module>
@import '@/assets/variables';

.content {
  max-width: 520px;
  padding: $space-150;
}

.status {
  margin-top: 0;
  margin-bottom: $space-75;
}

.description {
  margin: 0;
  white-space: pre-line;
}
</style>
